import {
	ONHANDINVENTORY,
	EXCEL_ONHAND_INVENTORY,
	INTRANSITINVENTORY,
	EXCEL_INTRANSIT_INVENTORY,
	INSTOCKINVENTORY,
	EXCEL_INSTOCK_INVENTORY,
	UNITS,
	UNIT,
	IN_STOCK,
} from '../../constants/constant';

export const getWeek = (weekFilter, startWeek, endWeek) => {
	if (weekFilter === -1) {
		return `Custom Week WK ${startWeek} - WK ${endWeek}`;
	} else if (weekFilter === 0) {
		return 'WMT Week to Date';
	} else if (weekFilter === 1) {
		return 'WMT Last Week';
	} else {
		return `WMT Last ${weekFilter} Weeks`;
	}
};

export const getName = (selectedTab, value) => {
	if (selectedTab === 'Sub-Category') {
		return `${selectedTab} ${value}`;
	} else if (selectedTab === 'Brand') {
		return `${selectedTab} ${value}`;
	} else {
		return `Store ${value}`;
	}
};

export const getExcelName = (name) => {
	if (name === ONHANDINVENTORY) {
		return EXCEL_ONHAND_INVENTORY;
	} else if (name === INTRANSITINVENTORY) {
		return EXCEL_INTRANSIT_INVENTORY;
	} else if (name === INSTOCKINVENTORY) {
		return EXCEL_INSTOCK_INVENTORY;
	} else {
		return name?.toUpperCase();
	}
};

export const getColumnLabel = (chartTitle, selectedBtn, type) => {
	const text = { ty: 'This year', ly: 'Last year' };
	if (chartTitle === `${IN_STOCK}%`) {
		return `${text[type]} value(%)`;
	}

	if (chartTitle === UNITS || selectedBtn === UNIT) {
		return `${text[type]} units`;
	}

	return `${text[type]} value($)`;
};

export const getreplenishmentColumnLabel = (type) => {
	const text = { ty: 'This year', ly: 'Last year' };
	return `${text[type]} value(%)`;
};

export const getTitle = (str = '') => {
	let txt;
	if (str === 'State Metric (all units are in millions)') {
		txt = 'State Metric';
	} else if (str === 'Store Metric (all units are in millions)') {
		txt = 'Store Metric';
	} else if (str === 'Net Sales - Stores') {
		txt = 'Net Sales by Store';
	} else if (str === 'NETSALES') {
		return 'Net Sales';
	} else {
		txt = str;
	}
	return txt?.replace(/[^-a-zA-Z ]/g, '');
};

export const isDashboard = () => {
	if(window.location.toString().includes('drilldownitem')) {
		return false;
	}
	return true;
}

export const getEventTrackingAttribute = (
	selectedTab
) => {
	const text = isDashboard() ? 'Dashboard' : `Item Details - ${selectedTab} Tab`
	return {
		string: `{"place": "${text}"}`,
	};
}

export const getLocationText = (
	selectedTab
) => {
	return isDashboard() ? 'from Dashboard' : `from ${selectedTab} Tab in Item details`
}

export const getEventTrackingDescription = (
	chartTitle,
	selectedTab,
) => {
	return `${getTitle(chartTitle)} excel report ${getLocationText(selectedTab)}`
}
